import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
})

Vue.config.productionTip = false

function readCsrfToken() {
  const match = document.cookie.split('; ').find((row) => row.startsWith('csrftoken='))
  return match ? match.split('=')[1] : null
}

axios.interceptors.request.use(
  (config) => {
    const currentPath = window.location.pathname
    if (currentPath.includes('/contactbook')) {
      return config
    }
    const token = readCsrfToken()
    if (token) {
      config.headers['X-CSRFToken'] = token
    }
    return config
  },
  (err) => Promise.reject(err)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      const currentPath = window.location.pathname
      if (currentPath.includes('/contactbook')) {
        localStorage.removeItem('id')
        localStorage.removeItem('isUserLogin')
        localStorage.removeItem('elder_name')
        router.push('/contactbook/login')
      } else {
        localStorage.removeItem('staff')
        localStorage.removeItem('isStaffLogin')
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

const siteMapping = process.env.VUE_APP_SITE_MAPPING || {}
const siteName = siteMapping[window.location.hostname] || 'AST'

new Vue({
  router,
  store,
  vuetify,
  provide: { siteName },
  render: (h) => h(App),
}).$mount('#app')
